/* ******************************************************** */
/* == Function cookie == */
function getCookie(name) {
    let decodedCookie = decodeURIComponent(document.cookie);
    let arrCookie = decodedCookie.split(";");
    let a = arrCookie.filter((cookieItem) => {
        let a = cookieItem.split("=");
        if (a[0].includes(name)) {
            return cookieItem;
        }
    })[0];
    return a;
}
function setExpires(day) {
    let d = new Date();
    d.setTime(d.getTime() + day * 24 * 60 * 60 * 1000); // correct
    // d.setTime(d.getTime() + 30 * 1000); // test short time
    let expires = "expires=" + d.toUTCString();
    return expires;
}
/* ======================================================== */

/* ******************************************************** */
/* == Function lockscroll ios == */
const fixedBody = (bodyPosition) => {
    const getScrollBarWidth = () => {
        let inner = document.createElement("p");
        inner.style.width = "100%";
        inner.style.height = "200px";

        let outer = document.createElement("div");
        outer.style.position = "absolute";
        outer.style.top = "0px";
        outer.style.left = "0px";
        outer.style.visibility = "hidden";
        outer.style.width = "200px";
        outer.style.height = "150px";
        outer.style.overflow = "hidden";
        outer.appendChild(inner);

        document.body.appendChild(outer);
        let w1 = inner.offsetWidth;
        outer.style.overflow = "scroll";
        let w2 = inner.offsetWidth;
        if (w1 == w2) w2 = outer.clientWidth;

        document.body.removeChild(outer);

        return w1 - w2;
    };
    
    if (document.body.classList.contains("js-fixed-body")) {
        document.body.classList.remove("js-fixed-body");
        document.body.style.position = "";
        document.body.style.overflow = "";
        document.body.style.width = "";
        document.body.style.paddingRight = "";
        document.body.style.top = "";
        window.scrollTo(0, bodyPosition);
    } else {
        document.body.classList.add("js-fixed-body");
        document.body.style.position = "fixed";
        document.body.style.overflow = "hidden";
        document.body.style.width = "100%";
        document.body.style.top = "-" + bodyPosition + "px";
        document.body.style.paddingRight = getScrollBarWidth() + "px";
    }
};
/* ======================================================== */

/* ******************************************************** */
/* == Function return list grid item == */
// data in: Array handle product
async function buildListItem(arr) {
    let data = await getJsonProduct(arr);
    let htmlListItem = buildList(data);
    return htmlListItem;

    function buildList(arrProduct) {
        let html = "";
        if (arrProduct.length > 0) {
            // arrProduct.reverse();
            arrProduct.forEach((element, value) => {
                html += buildItem(element, value);
            });
        }
        return html;
    }

    async function getJsonProduct(arrProduct) {
        let arr = await arrProduct.map((url) => fetch(location.origin + "/products/" + url + "?section_id=product-card-item"));
        return Promise.all(arr)
            .then((responses) => responses)
            .then((responses) => {
                return Promise.all(
                    responses.map((r) => {
                        if (r.ok) return r.text();
                    })
                );
            })
            .then((data) => data.filter((i) => i != undefined))
            .catch((err) => {
                console.log(err);
            });
    }

    function buildItem(text) {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-product-card-item").innerHTML;
        return `<li class="grid__item">${resultsMarkup}</li>`;
    }
}
/* ======================================================== */

/* ******************************************************** */
// set var css

function readHeights() {
    const h = {};
    h.windowHeight = window.innerHeight;
    h.announcementHeight = getHeight("#shopify-section-announcement-bar");
    h.headerHeight = getHeight("#shopify-section-header");
    h.searchMbHeight = getHeight("#form-search-mb");
    h.LogoIndexHeight = getHeight("#section-logo-index");
    h.slimBannerHeight = getHeight("#slimline-banner-top");

    return h;
}

function setVarsOnResize() {
    setVars();
    window.addEventListener("resize", setVars);
    window.addEventListener("scroll", setVars);
}

function setVars() {
    const { windowHeight, announcementHeight, headerHeight, searchMbHeight, LogoIndexHeight, slimBannerHeight } = readHeights();
    document.documentElement.style.setProperty("--full-height", `${windowHeight}px`);
    document.documentElement.style.setProperty("--announcement-height", `${announcementHeight}px`);
    document.documentElement.style.setProperty("--height-fixed-header", `${headerHeight + slimBannerHeight}px`);
    document.documentElement.style.setProperty("--height-search-mb", `${searchMbHeight}px`);
    document.documentElement.style.setProperty("--content-full", `${windowHeight - headerHeight}px`);
    document.documentElement.style.setProperty("--logo-index", `${LogoIndexHeight}px`);
}

function getHeight(selector) {
    const el = document.querySelector(selector);
    if (el) {
        return el.clientHeight;
    } else {
        return 0;
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setVarsOnResize();
});
